import styled from "styled-components";

export const Container = styled.div`
  padding: 16px;
  flex-grow: 0;
  max-width: 100%;
  flex-basis: 100%;
  display: flex;
  align-items: center;
  /* height: 100%; */
  .bp-card-inner-container {
    background: var(--prices-background);
    height: 100%;
    padding: 40px;
    border-radius: 48px;
    overflow: hidden;
    position: relative;
    .bp-card-content {
      height: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: nowrap;
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 2;
      .bp-card-text {
        position: relative;
        margin-right: 20px;
        h3 {
          font-size: 22px;
          margin-bottom: 12px;
          line-height: 1.33;
        }
        p {
          font-size: 16px;
          line-height: 1.5;
        }
        button {
          margin-top: 24px;
          height: 40px;
          border-radius: 20px;
          padding: 0 20px;
          color: #ffffff;
          padding: 6px 16px;
          font-size: 0.875rem;
          min-width: 64px;
          box-shadow: none;
          box-sizing: border-box;
          transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
            box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
            border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
          /* font-family: 'Inter', sans-serif; */
          font-weight: 500;
          line-height: 1.75;
          text-transform: none;
          background-color: var(--secondaryColor);
          border: none;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            opacity: 0.9;
          }
        }
      }
      img {
        width: 129px;
        max-width: 320px;
        overflow-clip-margin: content-box;
        overflow: clip;
      }
    }
  }
  .bp-card-inner-container {
    height: auto;
  }

  @media screen and (max-width: 600px) {
    .bp-card-content {
      flex-wrap: wrap !important;
      .bp-card-text {
        margin: 0 !important;
        button {
          width: 100%;
          margin-bottom: 20px;
        }
      }
      img {
        margin: 0 auto;
      }
    }
  }
  @media screen and (max-width: 950px) {
    .bp-card-content {
      max-width: 608px;
    }
  }
`;
